import ReactFullpage from "@fullpage/react-fullpage";
import Tools from "./containers/Tools";
import Skills from "./containers/Skills";
import AboutMe from "./containers/AboutMe";
import SocialMenu from "./components/SocialMenu";
import MobileSocialMenu from "./components/MobileSocialMenu";

import "./styles/App.css";
import Projects from "./containers/Projects";
import { projects } from "./const/data";

function App() {
  return (
    <div className="relative text-white">
      <SocialMenu />
      <MobileSocialMenu />
      <ReactFullpage
        navigation={true}
        autoScrolling={true} // Enable automatic scrolling
        fitToSection={true} // Ensure sections fit properly
        scrollingSpeed={2000}
        render={({ state, fullpageApi }) => {
          return (
            <ReactFullpage.Wrapper>
              <AboutMe />
              <Skills />
              <Tools />
              <Projects />
              {projects.map((item, index) => (
                <div
                  role="button"
                  key={item.imgSrc}
                  onClick={() => window.open(item.url, "_blank")}
                  className={`section page-container flex xl:!hidden`}
                >
                  <div>
                    <p className="text-2xl font-semibold xl:hidden">{item.title}</p>
                    <p className="text-description xl:hidden">{item.text}</p>
                  </div>
                  <img
                    src={require(`./assets/images/projects/${item.imgSrc}.png`)}
                    className="mt-2 xl:hidden"
                    alt={item.title}
                  />
                </div>
              ))}
            </ReactFullpage.Wrapper>
          );
        }}
      />
    </div>
  );
}

export default App;
